/**
 * The exact text next to the Order Form acceptance checkbox.
 *
 * MUST match `acceptanceCheckboxText` in server/config/agreementConfig.ts character for character:
 * the server rebuilds it from the same inputs and rejects the acceptance if they differ.
 */
export function acceptanceCheckboxText(params: {
    clientLegalName: string;
    tosVersion: string;
    dpaVersion?: string | null;
}): string {
    const dpa = params.dpaVersion ? ` and Data Processing Addendum (v${params.dpaVersion})` : '';
    return (
        `I have read and agree to the Aptive Index Terms of Service (v${params.tosVersion})${dpa} and this Order Form ` +
        `on behalf of ${params.clientLegalName}, and I represent that I have authority to bind ${params.clientLegalName}.`
    );
}
